<template>
<div>
  <b-modal :id="'baseEngineModal_' + type" size="xl" v-bind:title="this.getMotorName()" hide-footer>
    <div class="modal-body">
      <div v-if="engine === EngineTypes.NUM_NATURALES">
        <!-- Motor de Numeracion Natuarles -->
        <NaturalNumeration :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.NUM_ORDINALES">
        <!-- Motor de Numeracion Ordinales -->
        <OrdinalNumeration :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.NUM_FRACCIONES">
        <!-- Motor de Numeracion Fracciones -->
        <FractionsNumeration :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.NUM_ROMANOS">
        <!-- Motor de Numeracion Romano -->
        <RomanNumeration :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.NUM_DECIMALES">
        <!-- Motor de Numeracion Decimal -->
        <DecimalNumeration :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.NUM_POTENCIAS">
        <!-- Motor de Numeracion Potencia -->
        <PowerNumeration :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.NUM_PORCENTAJES">
        <!-- Motor de Numeracion Porcentajes -->
        <PercentagesNumeration :exercise="exercise" :type="type" :engine="engine" />
      </div>
       <div v-if="engine === EngineTypes.NUM_ENTEROS">
        <!-- Motor de Numeracion Enteros -->
        <IntegerNumeration :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.NUM_MIXTOS">
        <!-- Motor de Numeracion Mixto -->
        <MixedNumeration :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.SER_ENTEROS">
        <!-- Motor de Serie de Numeros Enteros -->
        <IntegerSequence :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.SER_DECIMALES">
        <!-- Motor de Serie de Numeros Decimales -->
        <DecimalSequence :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.SER_FRACCIONES">
        <!-- Motor de Serie de Fracciones -->
        <FractionSequence :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.SER_ORDINALES">
        <!-- Motor de Serie Ordinal -->
        <OrdinalSequence :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.HECHOSARIT">
        <!-- Motor de Hechos Arimeticos -->
        <ArithmeticFacts :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.OPERACIONES">
        <!-- Motor de operaciones -->
        <Operations :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.EQUIVALENCIAS">
        <!-- Motor de Equivalencias entre suma y multiplicacion -->
        <MultiplicationAdditionEquivalence :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.ALG_SUMRESTA">
        <!-- Motor de Suma y Resta -->
        <AlgorithmAdditionSubtraction :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.ALG_MULTI">
        <!-- Motor de Multiplicacion -->
        <AlgorithmMultiplication :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.ALG_SUMTRES">
        <!-- Motor de Suma de 3 opearadores -->
        <AlgorithmAdditionThreeOperators :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.ALG_DIVI">
        <!-- Motor de Algoritmo de division -->
        <AlgorithmDivision :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.PRO_SIMPLES">
        <!-- Motor de Problemas simples -->
        <ProblemSimples :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.PRO_FORMULA">
        <!-- Motor de Problemas de formula -->
        <ProblemFormula :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.PRO_MULTIPLES">
        <!-- Motor de Problemas multiples -->
        <ProblemMultiple :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.FICHACONTENIDO">
        <!-- Motor de fichas de contenido -->
        <FichaContenido :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.TIEMPO">
        <!-- Motor de instrumentral del tiempo -->
        <Time :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.TRATINFORMACION">
        <!-- Motor de  tratamiento de la infromación -->
        <InformationCharts :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.GEOPLANO">
        <!-- Motor de geoplanos -->
        <Geometry :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.MONEDAS">
        <!-- Motor de monedas y billetes -->
        <Money :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.SEXA_SUMRESTA">
        <!-- Motor de Suma Resta Sexagesimal -->
        <AdditionSubtractionSexagesimal :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.SEXA_MULTDIVI">
        <!-- Motor de Division Sexagesimal -->
        <MultiplicationDivisionSexagesimal :exercise="exercise" :type="type" :engine="engine" />
      </div>
       <div v-if="engine === EngineTypes.ECU_EQUIVALENCIAS">
        <!-- Motor de Equivalencias Ecuaciones -->
        <EquationsEquivalences :exercise="exercise" :type="type" :engine="engine" />
      </div>
       <div v-if="engine === EngineTypes.SEXA_CONVER">
        <!-- Motor de Conversion Sexagesimal -->
        <ConversionSexagesimal :exercise="exercise" :type="type" :engine="engine" />
      </div>
      <div v-if="engine === EngineTypes.ECU_RESOLUCION">
        <!-- Motor de Resolución de Ecuaciones -->
        <ResolutionEquations :exercise="exercise" :type="type" :engine="engine" />
      </div>
    </div>
  </b-modal>
</div>
</template>

<script>
/**
* Componenten base para integrar los motores
* en el componente de ejercicios. Para poder
* integrar los motores se debe seguir los siguientes
* pasos:
*
* 1. Dentro de este componente agregar un if por cada motor, ejemplo:
*      <div v-if="engine === 15">
*        <!-- Motor de operaciones -->
*        <Operations :exercise="exercise" :type="type" />
*      </div>
*
*    Esto es para visualizar solo el que corresponda. La variable engine corresponde
*    al id de la tabla motores de la base de datos.
*
* 2. Cada motor debe integrar las siguientes props y el mixin:
*    props: {
*      engine: Number, // type of engine from EngineTypes.js
*      exercise: Object,
*      type: String,
*    },
*    mixins: [engineMixin],
*
*    Este mixin se importa desde /mixins/engine.js
*
* 3. En el mounted del motor, para obtener los datos de elementos
*    o configuración. Agregar el siguiente if:
*
*    if (this.exercise !== null && (this.exercise.ID !== null && this.exercise.ID !== undefined)) {
*      await this.getMotorData(this.exercise.ID);
*    }
*
*    Basicamente es para saber si se está editanto un motor y si vienen los datos
*    desde el componenten de ejercicios (la petición http se hace ahí, no en el motor)
*    Por ejemplo, en el caso del motor de  operaciones, se usa el if para obtener
*    la concifugración y los elementos del motor.
*
*    Y luego de ese if agregar:
*
*    // Lee la data desde el storage
*    this.readFromStorage(this.type);
*
*    Esto es para leer los datos desde el storage, tiene prioridad siempre
*
* 4. Dentro del motor, en el componente exercise, debe recibir el prop exercice que llega desde el componente
*    ejercicios. Ejemplo:
*
*    <exercises ref="exercise_child" :exercise="exercise" :engine="engine"></exercises>
*
* 5. Al momento de guardar los datos en el motor con el sessionStorage, hacerlo así:
*
*    El parametro exerciseID Puede ser el ID del ejercicio de la base de datos, o una string que empieza por tempID_{type}_{activeExercise}
*
*    window.sessionStorage.setItem(`engine_${this.type}_${exerciseID}`, JSON.stringify(motorData));
*
*    Motor data debe tener los siguientes keys: exercise, configuration y elements. Ejemplo:
*       const motorData = {
*          exercise: datosEjercicios,
*          configuration: datosDeLaTablaConfiguraciones,
*          totalElements: selectedNumOpertion,
*          elements: datosElementos,
*        };
*
*    Para que se pueda identificar en el componente de ejercicios.
*
*    NOTA IMPORTANTE: Los nombres de las claves de exercise, configuration y elements deben
*                     ser iguales a los nombres de las columnas de la tabla en la db.
*                     Por otro lado en configuration asegurarse de pasar el campo ID.
*
* 6. En el mismo boton guardar, agregar este linea, al final luego de grabar en el session storage:
*
*    this.$root.$emit('bv::show::modal', `baseEngineModal_${this.type}`);
*/
import * as EngineTypes from './EngineTypes';
import Operations from './operations/Operations.vue';
import AlgorithmAdditionThreeOperators from './algorithmadditionthreeoperators/AlgorithmAdditionThreeOperators.vue';
import AlgorithmMultiplication from './algorithmmultiplication/AlgorithmMultiplication.vue';
import AlgorithmAdditionSubtraction from './algorithmadditionsubtraction/AlgorithmAdditionSubtraction.vue';
import AlgorithmDivision from './algorithmdivision/AlgorithmDivision.vue';
import NaturalNumeration from './naturalnumeration/NaturalNumeration.vue';
import IntegerNumeration from './integernumeration/IntegerNumeration.vue';
import OrdinalNumeration from './ordinalnumeration/OrdinalNumeration.vue';
import FractionsNumeration from './fractionsnumeration/FractionsNumeration.vue';
import RomanNumeration from './romannumeration/RomanNumeration.vue';
import DecimalNumeration from './decimalnumeration/DecimalNumeration.vue';
import PowerNumeration from './powernumeration/PowerNumeration.vue';
import PercentagesNumeration from './percentagsnumeration/PercentagesNumeration.vue';
import MixedNumeration from './mixednumeration/MixedNumeration.vue';
import ProblemSimples from './problemsimples/ProblemSimples.vue';
import ProblemFormula from './problemformula/ProblemFormula.vue';
import ProblemMultiple from './problemmultiple/ProblemMultiple.vue';
import FichaContenido from './fichacontenido/FichaContenido.vue';
import Time from './time/Time.vue';
import Money from './money/Money.vue';
import Geometry from './geometry/Geometry.vue';
import InformationCharts from './informationcharts/InformationCharts.vue';
import IntegerSequence from './integersequence/IntegerSequence.vue';
import DecimalSequence from './decimalsequence/DecimalSequence.vue';
import FractionSequence from './fractionsequence/FractionSequence.vue';
import OrdinalSequence from './ordinalsequence/OrdinalSequence.vue';
import ArithmeticFacts from './arithmeticfacts/ArithmeticFacts.vue';
import AdditionSubtractionSexagesimal from './additionsubtractionsexagesimal/AdditionSubtractionSexagesimal.vue';
import MultiplicationDivisionSexagesimal from './multiplicationdivisionsexagesimal/MultiplicationDivisionSexagesimal.vue';
import MultiplicationAdditionEquivalence from './multiplicationadditionequivalence/MultiplicationAdditionEquivalence.vue';
import ConversionSexagesimal from './conversionsexagesimal/ConversionSexagesimal.vue';
import EquationsEquivalences from './equationsequivalences/EquationsEquivalences.vue';
import ResolutionEquations from './resolutionequations/ResolutionEquations.vue';

export default {
  components: {
    Operations,
    AlgorithmAdditionThreeOperators,
    AlgorithmMultiplication,
    AlgorithmAdditionSubtraction,
    AlgorithmDivision,
    NaturalNumeration,
    IntegerNumeration,
    OrdinalNumeration,
    FractionsNumeration,
    RomanNumeration,
    DecimalNumeration,
    PowerNumeration,
    PercentagesNumeration,
    MixedNumeration,
    ProblemSimples,
    ProblemFormula,
    ProblemMultiple,
    FichaContenido,
    Time,
    Money,
    Geometry,
    InformationCharts,
    IntegerSequence,
    DecimalSequence,
    FractionSequence,
    OrdinalSequence,
    ArithmeticFacts,
    AdditionSubtractionSexagesimal,
    MultiplicationDivisionSexagesimal,
    MultiplicationAdditionEquivalence,
    ConversionSexagesimal,
    EquationsEquivalences,
    ResolutionEquations,
  },
  data() {
    return {
      EngineTypes: EngineTypes.default,
    };
  },
  props: {
    engine: Number,
    exercise: Object,
    type: String,
  },
  methods: {
    getMotorName() {
      switch (this.engine) {
        case EngineTypes.default.NUM_NATURALES:
          return 'Motor de Interacción - Numeración Naturales';
        case EngineTypes.default.NUM_ORDINALES:
          return 'Motor de Interacción - Numeración Ordinales';
        case EngineTypes.default.NUM_FRACCIONES:
          return 'Motor de Interacción - Numeración Fracciones';
        case EngineTypes.default.NUM_ROMANOS:
          return 'Motor de Interacción - Numeración Romanos';
        case EngineTypes.default.NUM_DECIMALES:
          return 'Motor de Interacción - Numeración Decimales';
        case EngineTypes.default.NUM_POTENCIAS:
          return 'Motor de Interacción - Numeración Potencias';
        case EngineTypes.default.NUM_PORCENTAJES:
          return 'Motor de Interacción - Numeración Porcentajes';
        case EngineTypes.default.NUM_ENTEROS:
          return 'Motor de Interacción - Numeración Enteros';
        case EngineTypes.default.NUM_MIXTOS:
          return 'Motor de Interacción - Numeración Mixtos';

        case EngineTypes.default.SER_ENTEROS:
          return 'Motor de Interacción - Series Enteros';
        case EngineTypes.default.SER_DECIMALES:
          return 'Motor de Interacción - Series Decimales';
        case EngineTypes.default.SER_FRACCIONES:
          return 'Motor de Interacción - Series Fracciones';
        case EngineTypes.default.SER_ORDINALES:
          return 'Motor de Interacción - Series Ordinales';

        case EngineTypes.default.HECHOSARIT:
          return 'Motor de Interacción - Hechos Aritméticos';
        case EngineTypes.default.OPERACIONES:
          return 'Motor de Interacción - Operaciones';
        case EngineTypes.default.EQUIVALENCIAS:
          return 'Motor de Interacción - Equivalencias';

        case EngineTypes.default.ALG_SUMRESTA:
          return 'Motor de Interacción - Algoritmica Suma y Resta';
        case EngineTypes.default.ALG_MULTI:
          return 'Motor de Interacción - Algoritmica Multiplicación';
        case EngineTypes.default.ALG_SUMTRES:
          return 'Motor de Interacción - Algoritmica Suma de 3 operandos';
        case EngineTypes.default.ALG_DIVI:
          return 'Motor de Interacción - Algoritmica División';

        case EngineTypes.default.PRO_SIMPLES:
          return 'Motor de Interacción - Problemas Aritméticos simples';
        case EngineTypes.default.PRO_FORMULA:
          return 'Motor de Interacción - Problemas de Fórmula';
        case EngineTypes.default.PRO_MULTIPLES:
          return 'Motor de Interacción - Problemas Multiples';

        case EngineTypes.default.FICHACONTENIDO:
          return 'Motor de Interacción - Ficha de contenido';
        case EngineTypes.default.TIEMPO:
          return 'Motor de Interacción - Instrumentral del Tiempo';
        case EngineTypes.default.TRATINFORMACION:
          return 'Motor de Interacción - Tratamiento de la Información';
        case EngineTypes.default.GEOPLANO:
          return 'Motor de Interacción - Geoplanos';
        case EngineTypes.default.MONEDAS:
          return 'Motor de Interacción - Monedas y Billetes';

        case EngineTypes.default.SEXA_SUMRESTA:
          return 'Motor de Interacción - Sexagesimal Suma y Resta';
        case EngineTypes.default.SEXA_MULTDIVI:
          return 'Motor de Interacción - Sexagesimal Multipliación y División';
        case EngineTypes.default.ECU_EQUIVALENCIAS:
          return 'Motor de Interacción - Equivalencias Ecuaciones';
        case EngineTypes.default.SEXA_CONVER:
          return 'Motor de Interacción - Conversion Sexagesimal';
        case EngineTypes.default.ECU_RESOLUCION:
          return 'Motor de Interacción - Resolución de Ecuaciones';

        default:
          return 'Motor de Interacción';
      }
    },
  },
};
</script>

<style>

.modal-title{
  font-weight: 900 !important;
}

</style>
